import React from 'react';
import AdminSidebarContent from './sidebar/AdminSidebarContent';
import '../../styles/layout/sidebar.css';

const Sidebar = () => {
  return (
    <aside className="admin-sidebar-paper">
      <AdminSidebarContent />
    </aside>
  );
};

export default Sidebar;
